import noop from 'utils/noop';

const defaultHeap = {
  appid: '',
  identity: '',
  loaded: false,
  track: noop,
  userId: '',
};

export const useUserTracking = () => {
  const { appid, identity, loaded = false, track = noop, userId } = window?.heap || defaultHeap;

  const handleTrack = (event: string, data?: Record<string, string | number | undefined>) => {
    const payload = {
      ...data,
      appid,
      identity,
      userId,
    };
    return track(event, payload);
  };

  return { appid, identity, loaded, track: handleTrack, userId };
};
